import React from 'react';
import api from '../services/api'; // 記得用 default import
import { useNavigate } from 'react-router-dom';
//import { tokenManager } from '../contexts/AuthContext';
import { useAuth } from '../contexts/AuthContext'; // 引入 context


const DevLoginButton = () => {
  const navigate = useNavigate();
  const isLocalDev = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const { login } = useAuth();
  if (!isLocalDev) return null; // UAT/正式環境都唔顯示,淨係本機 dev 見到

  const handleDevLogin = async () => {
    try {
      console.log('🚀 Attempting Dev Login...');
      const response = await api.post('/auth/dev-login/');
      const data = response.data;


      await login(data.tokens, data.user, null)
      /*if (data.tokens) {
        // 1. 存 Token
        tokenManager.setTokens(data.tokens.access_token, data.tokens.refresh_token, type='customer');

        // AuthContext 需要 user 才能通過檢查
        if (data.user) {
            tokenManager.setUserData(data.user, null);
            dispatch({ 
                type: 'LOGIN_SUCCESS', // 確保這個 type 對應你 reducer 的 case
                payload: data.user 
            });
        }

        // 2. 如果你有用 Context，這裡可能要 call login()
        // 但最簡單的方法是直接 reload 或者跳轉
        */
        console.log(`✅ Login Success: ${data.user.display_name}`);
        

        // 3. 改用 navigate 跳轉 (避免刷新，雖然存了 User 後刷新也沒問題了)
        navigate('/profile');
        // 3. 跳去 Profile 頁面測試
        //window.location.href = '/profile'; 
      //}
    } catch (error) {
      console.error('Dev Login Failed:', error);
      alert('開發登入失敗，請檢查 Backend 是否已啟動且 DEBUG=True' + error);
    }
  };

  return (
    <button
      onClick={handleDevLogin}
      style={{
        position: 'fixed',
        bottom: '80px', // 在 SuperDebugger 上面一點
        right: '20px',
        zIndex: 9999,
        padding: '10px 20px',
        backgroundColor: '#2ecc71',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        fontWeight: 'bold',
        cursor: 'pointer',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
      }}
    >
      🚀 Dev Login
    </button>
  );
};

export default DevLoginButton;